/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/scope */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* skeleton for food types, menu items, promotion tier */
import React from 'react';
import { Skeleton } from 'react-skeleton-generator';

function AdorCashListDetailsSkeleton() {
    return (
        <Skeleton.SkeletonThemeProvider>
            <div className="mt-[30px] border border-[#CBC7C7] rounded p-3 bg-[#F5F5FA]">
                <div className="flex">
                    <div className="w-[60%] border-r border-[#CBC7C7] pr-2">
                        <h5 className="text-xs2 font-semibold text-[#000000]"><Skeleton width="175px" height="20px" /></h5>
                        <div className="mt-2.5 flex items-center">
                            <Skeleton width="25px" height="25px" />
                            <div className="pl-4">
                                <p className="text-base font-semibold text-[#303030] pb-1"><Skeleton width="150px" height="15px" /></p>
                                <p className="text-xs13 font-normal text-[#555259]"><Skeleton width="150px" height="15px" /></p>
                            </div>
                        </div>
                        <div className="flex -mx-0.5 mt-2.5 justify-between">
                            <div className="px-0.5">
                                <p className="text-xs3 font-semibold text-[#808285] pb-1"><Skeleton width="150px" height="13px" /></p>
                                <p className="pt-1 text-sm font-normal text-[#090406]"><Skeleton width="150px" height="13px" /></p>
                            </div>
                            <div className="px-0.5">
                                <p className="text-xs3 font-semibold text-[#808285] pb-1"><Skeleton width="150px" height="13px" /></p>
                                <p className="pt-1 text-sm font-normal text-[#090406] break-words"><Skeleton width="150px" height="13px" /></p>
                            </div>
                            <div className="px-0.5">
                                <p className="text-xs3 font-semibold text-[#808285] pb-2"><Skeleton width="150px" height="13px" /></p>
                                <p className="pt-1 text-sm font-normal text-[#090406] break-words "><Skeleton width="150px" height="13px" /></p>
                            </div>
                            <div className="px-0.5 flex items-center self-end pb-1 relative">
                                <p className="text-xs3 font-semibold text-[#808285]"><Skeleton width="150px" height="13px" /></p>
                            </div>
                        </div>
                    </div>
                    <div className="w-[40%] pl-5">
                        <div className="flex -mx-0.5 border-b border-[#CBC7C7] pb-2.5">
                            <div className="w-1/2 px-0.5">
                                <p className="text-xs6 font-semibold text-[#808285] pb-2"><Skeleton width="150px" height="18px" /></p>
                                <p className="text-xs7 font-normal text-[#090406]"><Skeleton width="150px" height="18px" /></p>
                            </div>
                            <div className="w-1/2 px-0.5">
                                <p className="text-xs6 font-semibold text-[#808285] pb-2"><Skeleton width="150px" height="18px" /></p>
                                <p className="text-xs7 font-normal text-[#090406]"><Skeleton width="150px" height="18px" /></p>
                            </div>
                        </div>
                        <div className="pt-3.5">
                            <div className="w-full">
                                <p className="text-xs6 font-semibold text-[#808285] pb-2"><Skeleton width="150px" height="18px" /></p>
                                <p className="text-xs7 font-normal text-[#090406]"><Skeleton width="150px" height="18px" /></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Skeleton.SkeletonThemeProvider>

    );
}

export default AdorCashListDetailsSkeleton;
